import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  private route = inject(ActivatedRoute);

  getQueryParams(paramKeys: string[]): Observable<Params> {
    return this.route.queryParams.pipe(
      map((params) => {
        const result: Params = {};
        paramKeys.forEach((key) => {
          if (params[key] !== undefined) {
            result[key] = params[key];
          }
        });
        return result;
      }),
    );
  }

  getQueryParam(paramKey: string): Observable<string | null> {
    return this.route.queryParams.pipe(
      map((params) => params[paramKey] || null),
    );
  }
}
